
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".997","width":"18.781","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M5.085 9.212l-.073.068a.387.387 0 00.29.123h2.295v4.688c0 .22.179.4.4.4h4.787c.222 0 .4-.18.4-.4v-4.69h2.294a.4.4 0 00.369-.553.393.393 0 00-.09-.144h0l-5.073-5.06a.107.107 0 00-.012-.014l-.071.07M5.085 9.213l-.072.069a.416.416 0 010-.576l.001-.001h0l5.082-5.06a.106.106 0 01.012-.014l.07.07M5.086 9.213a.287.287 0 00.213.09l-.213-.527a.316.316 0 000 .437zM10.179 3.7l-.072-.07c.077-.08.18-.12.282-.12m-.21.19l-.002.002v.002l.002-.004zm.21-.19a.388.388 0 01.284.12l-.072.07m-.212-.19s0 0 0 0v.1m0-.1s0 0 0 0v.1m.212.09a.01.01 0 01.002.003l.002.003-.215-.097m.211.09a.288.288 0 00-.211-.09m.302.048v.001h0s0 0 0 0zm2.092 4.945a.4.4 0 00-.399.4v4.688h-3.99V9.003a.4.4 0 00-.399-.4H6.258l4.132-4.112 4.125 4.112h-1.73z","fill":"#313131","stroke":"#313131","stroke-width":".2"}})])
          )
        }
      }
    